import React from 'react';

// Components
import { IconButton } from '@/views/components/buttons';
import { Tooltip } from '@/views/components/tooltips';

// Types
import DropdownItem from '@/types/dropdown-item';
import { UUID } from '@/types/global';

// Utils
import { formatMessage } from '@/utils/i18n';

interface HistoricalScenariosFilterItemActionsProps {
  item: DropdownItem;
  onDeleteScenario: (id: UUID) => void;
  onEditScenario: (id: UUID) => void;
}

const HistoricalScenariosFilterItemActions: React.FC<HistoricalScenariosFilterItemActionsProps> = ({ item, onDeleteScenario, onEditScenario }) => {
  const { canDelete, canEdit } = item;

  if (!canDelete && !canEdit) {
    return null;
  }

  const deleteTooltipMessage = formatMessage('Common.Remove');
  const editTooltipMessage = formatMessage('Common.Edit');

  return (
    <>
      {canEdit && (
        <Tooltip className="custom-tooltip-v2 group-option-action" effect="solid" message={editTooltipMessage}>
          <IconButton ariaLabel={editTooltipMessage} className="group-option-action-button" icon="ds-edit" onClick={() => onEditScenario(item.value)} />
        </Tooltip>
      )}
      {canDelete && (
        <Tooltip className="custom-tooltip-v2 group-option-action" effect="solid" message={deleteTooltipMessage}>
          <IconButton ariaLabel={deleteTooltipMessage} className="group-option-action-button" icon="ds-delete" onClick={() => onDeleteScenario(item.value)} />
        </Tooltip>
      )}
    </>
  );
};

export default HistoricalScenariosFilterItemActions;
